import { render } from "./Data.vue?vue&type=template&id=1aecdcc4&scoped=true&lang=true"
import script from "./Data.vue?vue&type=script&lang=js"
export * from "./Data.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1aecdcc4"

export default script